import {observer, useLocalStore} from '@api'
import {Menu, MenuDivider} from '@blueprintjs/core'
import {IMaterialTooltipPlacement, Popover2, Tooltip2} from '@api'
import {CardSizeSliderProps, ContextMenuItem, HeroCardsForGroupingLevelFieldContextMenuItem, SpecSwatchForGroupingLevelContextMenuItem, useGroupByGroupStore, useGrouping, useVipLocalStore} from '@modules'
import {defaultGroupBySettings, GroupByGrouping, StoresInstance, ui, useCatalog} from '@stores'
import {VipLocalStore} from '@modules'
import {icons} from '@stores/ui'
import {PrimaryIconButton} from 'centric-ui-components'
import {action, computed} from 'mobx'
import React, { Fragment } from 'react'
import * as css from './GroupSwatchesContextMenu.css'

export const ChooseSwatchesSubmenuItem = observer(function ChooseSwatchesSubmenu() {
  const store = useGroupByGroupStore()
  if (!store?.groupBy.canShowSwatchesAndHeroCards || (store && store?.grouping?.level != 0)) return null

  return (
    <ContextMenuItem text='Swatches' icon={icons.chooseSwatches}>
      <GroupSwatchesManagementPanel />
    </ContextMenuItem>)
})

export class GroupSwatchesManagementPanelStore extends VipLocalStore{
  constructor(stores: StoresInstance,public grouping: GroupByGrouping) {
    super(stores)
    this.grouping = this.grouping || this.groupBy.catalogItemsGroup
    this.grouping.swatchManagementStore = this
  }

  get settings() {
    return this.groupBy.individualGroupSettings
  }

  @action onChangeSwatchSize = (e, size: number) => {
    this.grouping.settingsForLevel.swatchSize = size
  }

  @action onResetSwatchSize = () => {
    this.grouping.settingsForLevel.swatchSize = defaultGroupBySettings.settingsForLevel[0].swatchSize
  }

  @computed get sliderProps() : CardSizeSliderProps {
    const {settings, onChangeSwatchSize, onResetSwatchSize, } = this
    return {
      min: 1,
      max: 50,
      value: this.grouping.settingsForLevel.swatchSize,
      onChange: onChangeSwatchSize,
      onDoubleClick: onResetSwatchSize,
      tooltipTitle: 'Swatch Sizes'
    }
  }
}

export const GroupSwatchesManagementPanel = observer(() => {
  const {availableSwatchFields, groupBy, groupBy: {settings: {showSwatches, hideCatalogItemsOnSwatchHover, showSwatchesWhenCollapsed}, toggleHideCatalogItemsOnSwatchHover, toggleCardSwatches, toggleShowSwatchesWhenCollapsed}, id} = useCatalog(),
    grouping = useGrouping() ?? groupBy.firstGroup,
    store = useVipLocalStore((ws) => new GroupSwatchesManagementPanelStore(ws, grouping))

  return <Fragment>
    <ContextMenuItem active={showSwatches} text={`Show Swatches`} onClick={toggleCardSwatches}/>
    <ContextMenuItem active={showSwatchesWhenCollapsed} text={`Show when Collapsed`} onClick={toggleShowSwatchesWhenCollapsed}/>
    <ContextMenuItem active={hideCatalogItemsOnSwatchHover === true} text={`Hide Catalog Items on Swatch Hover`} onClick={toggleHideCatalogItemsOnSwatchHover}/>
    {/*<ContextMenuItem active={!showSwatches} text={<Switch onClick={toggleCardSwatches}/>} />*/}
    <MenuDivider />
    {/*<CardSizeSlider {...sliderProps} />*/}
    {/*<MenuDivider/>*/}
    <ContextMenuItem icon={icons.clear} text={`Clear Swatches`} disabled={!grouping?.clearSwatches} onClick={grouping?.clearSwatches}/>
    <div
      className={css.swatchFields}
         style={{'--rows': Math.min(availableSwatchFields.length, 6)} as any}>
      {availableSwatchFields.map(f => <SpecSwatchForGroupingLevelContextMenuItem field={f} key={f.field} grouping={grouping}/>)}
      {false && groupBy.groupByFields.map(f => <SpecSwatchForGroupingLevelContextMenuItem field={f} key={f.field} grouping={grouping}/>) /* Doesn't work yet would be great to have text swatches for enum value fields */}
    </div>
  </Fragment>
});

export const HeroCardsToolbarButton = observer<{ tooltipPlacement?: IMaterialTooltipPlacement }>(function HeroCardsToolbarButton({tooltipPlacement}) {
  const {strings, groupBy, isShowingAssortment} = useCatalog(),
    {toggleShowHeroCards} = groupBy

  if (!ui.settings.groupByHeroCards || !groupBy.canShowSwatchesAndHeroCards) return null

  return (
    <Popover2 interactionKind='hover'
              placement={tooltipPlacement || 'bottom'}
              disabled={isShowingAssortment}
              content={<Menu>
                <HeroCardsManagementPanel/>
              </Menu>}>
      <Tooltip2 content={strings.showHeroCards} placement={tooltipPlacement || 'bottom'}>
        <PrimaryIconButton
          icon={icons.heroCards}
          active={groupBy.settings.heroCards.show === true}
          onClick={toggleShowHeroCards}
        />
      </Tooltip2>
    </Popover2>
  )
});

export const ChooseSubgroupSubmenu = observer(function ChooseSubgroupSubmenu() {
  const catalog = useCatalog(),
    {groupBy} = catalog

  if (!DEBUG) return null // YFTS-8505
  if (!groupBy.canShowSwatchesAndHeroCards) return null

  return (
    <ContextMenuItem text='Hero Cards' icon={icons.heroCards}>
      <HeroCardsManagementPanel />
    </ContextMenuItem>)
})

export const HeroCardsManagementPanel = observer(function HeroCardsManagementPanel() {
  const {availableSwatchFields, groupBy: {settings: {heroCards: {show, hideCollapsed}}, toggleShowHeroCards, toggleHideHeroCardsInCollapsedGroups}} = useCatalog()

  if (!DEBUG) return null // YFTS-8505

  return (
    <Fragment>
      <ContextMenuItem active={show} text={`Show Hero Cards`} onClick={toggleShowHeroCards}/>
      <ContextMenuItem active={!hideCollapsed} text={`Show when Collapsed`} onClick={toggleHideHeroCardsInCollapsedGroups}/>
      <MenuDivider/>
      <div className={css.swatchFields} style={{'--rows': Math.min(availableSwatchFields.length, 6)} as any}>
        {availableSwatchFields.map(f => <HeroCardsForGroupingLevelFieldContextMenuItem field={f} key={f.field} />)}
      </div>
    </Fragment>)
})

/*

 */


// WEBPACK FOOTER //
// ./src/modules/contextMenus/menus/internal/GroupSwatchesContextMenu.tsx